import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'dayOfWeek'
})
export class DayOfWeekPipe implements PipeTransform {
    transform(days: { date: string, totaltime_minutes: number }[], dayNum: number): { date: string, totaltime_minutes: number } | null {
        return days.find(d => new Date(d.date).getDay() === dayNum) ?? null;
    }
}

